import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';

import { LandingComponent } from './landing/landing.component';
import { ProfileComponent } from './profile/profile.component';
import { SignupComponent } from './signup/signup.component';

import { AgmCoreModule } from '@agm/core';
import { TwentyFourErpComponent } from './twenty-four-erp/twenty-four-erp.component';
import {RouterModule} from '@angular/router';
import { PolicyComponent } from './policy/policy.component';

@NgModule({
    imports: [
        CommonModule,
        FormsModule,
        NgbModule,
        AgmCoreModule,
        RouterModule
    ],
    declarations: [
        LandingComponent,
        SignupComponent,
        ProfileComponent,
        TwentyFourErpComponent,
        PolicyComponent
    ]
})
export class ExamplesModule { }
